module.exports = __webpack_public_path__ + "static/media/BLungHealthClinic.1431786e.png";